import {Component, OnInit} from '@angular/core';
import {CustomerApprovalService} from '../../services/customer-approval/customer-approval.service';
import {CustomerRegistrationService} from '../../services/customer-registration/customer-registration.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators} from '@angular/forms';
import {StateCountry} from '../../shared/common-components/common-structure';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {DataService} from '../../services/data.service';
import {CustomerApproval} from './customer-approval';
import {CommonValidators} from '../../shared/common-components/common-validators';
import {of} from 'rxjs';

@Component({
    selector: 'app-customer-approval',
    templateUrl: './customer-approval.component.html',
    styleUrls: ['./customer-approval.component.css'],
    standalone: false
})

export class CustomerApprovalComponent implements OnInit {
  registrationSuccessful = false;
  registrationFailure = false;
  isRegistrationTypeUser = false;
  isRegistrationRejected = false;
  customerApprovalForm: UntypedFormGroup;
  registerDetails: any;
  registrationStatus: any;
  private tmssloader;
  userPermission = [];
  currentPermissions = '';
  statusTypes: string[] = ['Accept', 'Reject'];
  savedCustomer: CustomerApproval;
  registrationId: any = 0;
  registrationType: any = '';
  message: any = '';
  selectedPermissions = [];
  stateList: any;
  countryList: any;
  constructor(private customerApprovalService: CustomerApprovalService,
              private customerRegistrationService: CustomerRegistrationService,
              private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private loader: LoadingService,
              private dataService: DataService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {
    this.tmssloader = this.loader;
    this.createForm();
    this.registrationId = this.route.snapshot.queryParamMap.get('userRegisterId');
    this.getStateList();
    this.getCountryList();
    this.customerApprovalService.getCustomerApprovalDetails(this.registrationId).subscribe(
      regDetails => {
        if (regDetails !== null) {
          this.registerDetails = regDetails;
          this.registrationType = this.registerDetails.registrationType;
          switch (this.registerDetails.registrationStatus) {
            case 'Accepted':
              this.registrationStatus = 'Accept';
              break;
            case 'Rejected':
              this.registrationStatus = 'Reject';
              break;
            default:
              this.registrationStatus = this.registerDetails.registrationStatus;
              break;
          }
          if (this.registerDetails.registrationType === 'User') {
            this.isRegistrationTypeUser = true;
          }
          if (this.registrationStatus === 'Accept') {
            this.isRegistrationRejected = true;
          }
          this.checkFormValidators();
          this.initValuesToForm(regDetails);
        }
      });
    of(this.getPermissions()).subscribe(x => {
      this.userPermission = x;
      this.addCheckboxes();
    });

    this.formControlValueChanged();

  }

  getPermissions() {
    return [
      {name: 'HHG'},
      {name: 'FRT'}
    ];
  }

  /*
   * Initializing form  values with DB values
  */
  initValuesToForm(values?) {
    let phoneValue = null;
    let agencyValue = null;
    let bureauValue = null;
    if (values !== undefined && values !== null) {
      phoneValue = values.reportingOfficialPhone.replace(/-/g, '');
      agencyValue = values.agencyName + ' - ' + values.agencyCode;
      bureauValue = values.bureauName + ' - ' + values.bureauCode;
    }
    this.customerApprovalForm.controls['reportingOfficialPhone'].setValue(phoneValue);
    this.customerApprovalForm.controls['firstName'].setValue(values ? values.firstName : null);
    this.customerApprovalForm.controls['middleInitial'].setValue(values ? values.middleInitial : null);
    this.customerApprovalForm.controls['lastName'].setValue(values ? values.lastName : null);
    this.customerApprovalForm.controls['email'].setValue(values ? values.email : null);
    this.customerApprovalForm.controls['phone'].setValue(values ? values.phone : null);
    this.customerApprovalForm.controls['phoneExtension'].setValue(values ? values.phoneExtension : null);
    this.customerApprovalForm.controls['reportingOfficialFirstName'].setValue(values ? values.reportingOfficialFirstName : null);
    this.customerApprovalForm.controls['reportingOfficialLastName'].setValue(values ? values.reportingOfficialLastName : null);
    this.customerApprovalForm.controls['reportingOfficialMiddleInitial'].setValue(values ? values.reportingOfficialMiddleInitial : null);
    this.customerApprovalForm.controls['reportingOfficialTitle'].setValue(values ? values.reportingOfficialTitle : null);
    this.customerApprovalForm.controls['reportingOfficialAddressLine1'].setValue(values ? values.reportingOfficialAddressLine1 : null);
    this.customerApprovalForm.controls['reportingOfficialAddressLine2'].setValue(values ? values.reportingOfficialAddressLine2 : null);
    this.customerApprovalForm.controls['reportingOfficialCity'].setValue(values ? values.reportingOfficialCity : null);
    this.customerApprovalForm.controls['reportingOfficialState'].setValue(values ? values.reportingOfficialState : null);
    this.customerApprovalForm.controls['reportingOfficialZip'].setValue(values ? values.reportingOfficialZip : null);
    this.customerApprovalForm.controls['reportingOfficialCountry'].setValue(values ? values.reportingOfficialCountry : null);
    this.customerApprovalForm.controls['reportingOfficialPhoneExtension'].setValue(values ? values.reportingOfficialPhoneExtension : null);
    this.customerApprovalForm.controls['reportingOfficialEmail'].setValue(values ? values.reportingOfficialEmail : null);
    if (this.isRegistrationRejected) {
      if (this.isRegistrationTypeUser) {
        this.customerApprovalForm.controls['firstName'].disable();
        this.customerApprovalForm.controls['middleInitial'].disable();
        this.customerApprovalForm.controls['lastName'].disable();
        this.customerApprovalForm.controls['phone'].disable();
        this.customerApprovalForm.controls['phoneExtension'].disable();
      }
      this.customerApprovalForm.get('frtAccess').disable();
      this.customerApprovalForm.get('hhgAccess').disable();
      this.customerApprovalForm.controls['reportingOfficialFirstName'].disable();
      this.customerApprovalForm.controls['reportingOfficialLastName'].disable();
      this.customerApprovalForm.controls['reportingOfficialMiddleInitial'].disable();
      this.customerApprovalForm.controls['reportingOfficialAddressLine1'].disable();
      this.customerApprovalForm.controls['reportingOfficialAddressLine2'].disable();
      this.customerApprovalForm.controls['reportingOfficialCity'].disable();
      this.customerApprovalForm.controls['reportingOfficialState'].disable();
      this.customerApprovalForm.controls['reportingOfficialZip'].disable();
      this.customerApprovalForm.controls['reportingOfficialCountry'].disable();
      this.customerApprovalForm.controls['reportingOfficialPhone'].disable();
      this.customerApprovalForm.controls['reportingOfficialPhoneExtension'].disable();

      this.customerApprovalForm.controls['registrationStatus'].setValue(this.registrationStatus);
      this.customerApprovalForm.controls['registrationStatus'].disable();
      this.customerApprovalForm.controls['rejectReason'].disable();
    } else {
      this.customerApprovalForm.controls['registrationStatus'].setValue(null);
    }
    this.customerApprovalForm.controls['rejectReason'].setValue(values ? values.rejectReason : null);
    // this.customerApprovalForm.controls['userPermission'].setValue(values ? values.permissions : null);
    this.customerApprovalForm.controls['agencyName'].setValue(agencyValue);
    this.customerApprovalForm.controls['bureauName'].setValue(bureauValue);

    //this.customerApprovalForm.get('frtAccess').setValue(false);
    //this.customerApprovalForm.get('hhgAccess').setValue(false);
    if (values.permissions === 'FRT') {
      // this.customerApprovalForm.get('frtAccess').setValue(true);
      this.customerApprovalForm.controls['permissionReadOnly'].setValue('Freight');
    }
    if (values.permissions === 'HHG') {
      // this.customerApprovalForm.get('hhgAccess').setValue(true);
      this.customerApprovalForm.controls['permissionReadOnly'].setValue('Household Goods');
    }
    if (values.permissions === 'HHG & FRT') {
      //  this.customerApprovalForm.get('frtAccess').setValue(true);
      this.customerApprovalForm.controls['permissionReadOnly'].setValue('Freight');
    }
    // Disable form fields if record type is 'User'
    if (this.isRegistrationTypeUser) {
      this.customerApprovalForm.controls['reportingOfficialFirstName'].disable();
      this.customerApprovalForm.controls['reportingOfficialMiddleInitial'].disable();
      this.customerApprovalForm.controls['reportingOfficialLastName'].disable();
    }
    this.currentPermissions = values.permissions;
  }

  /*
   * Creating form fields with default values
  */
  createForm() {
    this.customerApprovalForm = this.fb.group({
      agencyName: '',
      bureauName: '',
      permissionReadOnly: '',
      firstName: new UntypedFormControl('', [Validators.maxLength(35)]),
      lastName: new UntypedFormControl('', [Validators.maxLength(35)]),
      middleInitial: new UntypedFormControl('', [Validators.maxLength(1)]),
      email: new UntypedFormControl('', [Validators.maxLength(254)]),
      phone: new UntypedFormControl('', [Validators.maxLength(20)]),
      phoneExtension: new UntypedFormControl('', [Validators.maxLength(10)]),
      reportingOfficialFirstName: new UntypedFormControl('', [Validators.maxLength(35)]),
      reportingOfficialLastName: new UntypedFormControl('', [Validators.maxLength(35)]),
      reportingOfficialMiddleInitial: new UntypedFormControl('', [Validators.maxLength(1)]),
      reportingOfficialTitle: new UntypedFormControl('', [Validators.maxLength(45)]),
      reportingOfficialAddressLine1: new UntypedFormControl('', [Validators.maxLength(45)]),
      reportingOfficialAddressLine2: new UntypedFormControl('', [Validators.maxLength(45)]),
      reportingOfficialCity: new UntypedFormControl('', [Validators.maxLength(45)]),
      reportingOfficialState: new UntypedFormControl('null'),
      reportingOfficialZip: new UntypedFormControl('', [Validators.maxLength(5)]),
      reportingOfficialCountry: new UntypedFormControl('null'),
      reportingOfficialPhone: new UntypedFormControl('', [Validators.maxLength(20)]),
      reportingOfficialPhoneExtension: new UntypedFormControl('', [Validators.maxLength(14)]),
      reportingOfficialEmail: new UntypedFormControl('', [Validators.maxLength(254)]),
      userPermission: new UntypedFormArray([]),
      registrationStatus: new UntypedFormControl('null'),
      rejectReason: new UntypedFormControl('')
    });

  }


  /**
   *  update customer, need to handle save in the server side
   * @param: form
   */
  updateCustomer(form) {
    this.tmssloader.show();
    form.userRegisterId = this.registrationId;
    /*
    if (form.frtAccess && form.hhgAccess) {
      form.permissions = 'HHG & FRT';
    } else if (form.frtAccess) {
      form.permissions = 'FRT';
    } else if (form.hhgAccess) {
      form.permissions = 'HHG';
    } */
    if (form.permissionReadOnly === "Household Goods" ) {
      form.permissions = 'HHG';
    } else if (form.permissionReadOnly === "Freight") {
      form.permissions = 'FRT';
    }
    form.registrationStatus = form.registrationStatus === 'Accept' ? 'Accepted' : 'Rejected';
    this.customerApprovalService.updateCustomerApprovalDetails(form).subscribe(res => {
      this.message = JSON.stringify(res).replace(/"/g, '');
      this.registrationSuccessful = true;
      this.registrationFailure = false;
    }, (error) => {
      this.registrationFailure = true;
      this.registrationSuccessful = false;
      this.message = 'Customer Approval process failed. Please retry.';
      this.tmssloader.hide();
    }, () => {
      this.tmssloader.hide();
    });
    window.scroll(0, 0);
    return;
  }


  /*
   * get all State values
  */
  getStateList() {
    this.tmssloader.show();
    this.customerRegistrationService.getAllStates('State').subscribe(
      states => {
        this.stateList = states as StateCountry[];
        this.tmssloader.hide();
      }, (error) => {
        this.alertService.error('State drop down did not get populated');
        this.tmssloader.hide();
      });
  }

  /*
   * get all country values
  */
  getCountryList() {
    this.tmssloader.show();
    this.customerRegistrationService.getAllStates('Country').subscribe(
      countries => {
        this.countryList = countries as StateCountry[];
        this.tmssloader.hide();
      }, (error) => {
        this.alertService.error('Country drop down did not get populated');
        this.tmssloader.hide();
      });

  }

  minSelectedCheckboxes(min = 1) {
    const validator: ValidatorFn = (formArray: UntypedFormArray) => {
      const totalSelected = formArray.controls
        .map(control => control.value)
        .reduce((prev, next) => next ? prev + next : prev, 0);

      return totalSelected >= min ? null : {required: true};
    };

    return validator;
  }


  numericsOnly(c: UntypedFormControl) {
    const phoneNumber = /^[0-9]*$/;
    return phoneNumber.test(c.value) ? null : {
      numericsOnly: {
        valid: false
      }
    };
  }


  addCheckboxes() {
    this.userPermission.map((o, i) => {
      const control = new UntypedFormControl(i === 0); // if first item set to true, else false
      (this.customerApprovalForm.controls.userPermission as UntypedFormArray).push(control);
    });
  }

  /*
   * Assigning form fields 'required' or 'not' by registration type
  */
  checkFormValidators() {
    this.customerApprovalForm.get('userPermission').setValidators(this.minSelectedCheckboxes(1));
    this.customerApprovalForm.get('registrationStatus').setValidators([Validators.required]);
    if (this.isRegistrationTypeUser) {
      this.customerApprovalForm.get('firstName').setValidators([Validators.required]);
      this.customerApprovalForm.get('lastName').setValidators([Validators.required]);
      this.customerApprovalForm.get('email').setValidators([Validators.required, CommonValidators.email]);
      this.customerApprovalForm.get('phone').setValidators([Validators.required, Validators.minLength(10), this.numericsOnly]);
      this.customerApprovalForm.get('reportingOfficialTitle').setValidators([Validators.required]);
      this.customerApprovalForm.get('reportingOfficialAddressLine1').setValidators([Validators.required]);
      this.customerApprovalForm.get('reportingOfficialCity').setValidators([Validators.required]);
      this.customerApprovalForm.get('reportingOfficialState').setValidators([Validators.required]);
      this.customerApprovalForm.get('reportingOfficialZip').setValidators([Validators.required, this.numericsOnly, CommonValidators.lengthFive, CommonValidators.allZeros]);
      this.customerApprovalForm.get('reportingOfficialCountry').setValidators([Validators.required]);
      this.customerApprovalForm.get('reportingOfficialPhone').setValidators([Validators.required, Validators.minLength(10), this.numericsOnly]);
    } else {
      this.customerApprovalForm.get('reportingOfficialFirstName').setValidators([Validators.required]);
      this.customerApprovalForm.get('reportingOfficialLastName').setValidators([Validators.required]);
      this.customerApprovalForm.get('reportingOfficialTitle').setValidators([Validators.required]);
      this.customerApprovalForm.get('reportingOfficialAddressLine1').setValidators([Validators.required]);
      this.customerApprovalForm.get('reportingOfficialCity').setValidators([Validators.required]);
      this.customerApprovalForm.get('reportingOfficialState').setValidators([Validators.required]);
      this.customerApprovalForm.get('reportingOfficialZip').setValidators([Validators.required, this.numericsOnly, CommonValidators.lengthFive, CommonValidators.allZeros]);
      this.customerApprovalForm.get('reportingOfficialCountry').setValidators([Validators.required]);
      this.customerApprovalForm.get('reportingOfficialEmail').setValidators([Validators.required, CommonValidators.email]);
      this.customerApprovalForm.get('reportingOfficialPhone').setValidators([Validators.required, Validators.minLength(10), this.numericsOnly]);
    }


  }

  formControlValueChanged() {
    const rejectReasonControl = this.customerApprovalForm.get('rejectReason');
    const reportingOfficialCountryControl = this.customerApprovalForm.get('reportingOfficialCountry');
    this.customerApprovalForm.get('registrationStatus').valueChanges.subscribe(
      (status: string) => {
        if (status === 'Reject') {
          rejectReasonControl.setValidators([Validators.required]);
        }
        if (status === 'Accept') {
          rejectReasonControl.setValidators(null);
        }
        rejectReasonControl.updateValueAndValidity();
      });

  }

  callCustomerApprovalList() {
    this.router.navigateByUrl('/customerapprovallist');

  }

  /*
   * Check whether select controls are selected valid items are not
  */
  checkSelectControlsSelected() {
    let flag = false;
    if (this.customerApprovalForm.controls['reportingOfficialState'].value === 'null' ||
      this.customerApprovalForm.controls['reportingOfficialCountry'].value === 'null' ||
      this.customerApprovalForm.controls['registrationStatus'].value === 'null') {
      flag = true;
    }

    return flag;
  }


}
